export interface AdminSitesSearch {
  q?: string;
  /** FE-01 §6.1 name of the billing filter; kept as an alias of `billing_state`. */
  state?: string;
  billing_state?: string;
  publication_state?: string;
  seller?: string;
  flagged?: boolean;
  sort?: "business" | "seller" | "state" | "next_charge";
  dir?: "asc" | "desc";
}

export interface AdminMessagesSearch {
  channel?: string;
  status?: string;
  template?: string;
}

/**
 * Keeps the listed params that match `re` (route configs ship in the entry chunk, so this stays
 * tiny; values are only used as API filters).
 */
function pick(search: Record<string, unknown>, keys: string, re: RegExp): Record<string, string> {
  const out: Record<string, string> = {};
  for (const key of keys.split(" ")) {
    const value = search[key];
    if (typeof value === "string" && re.test(value)) out[key] = value;
  }
  return out;
}

/** `/app/admin/sites` filters (FE-01 §6.1, FE-14 FR-FE14-05), kept in the URL (AC-09). */
export function validateAdminSitesSearch(search: Record<string, unknown>): AdminSitesSearch {
  const out: AdminSitesSearch = {
    ...pick(search, "q seller", /^[^<>]{1,100}$/),
    ...pick(search, "state billing_state publication_state", /^[a-z_]{1,20}$/),
  };
  if (search.flagged === true || search.flagged === "true") out.flagged = true;
  if (/^(business|seller|state|next_charge)$/.test(String(search.sort)))
    out.sort = search.sort as AdminSitesSearch["sort"];
  if (search.dir === "asc" || search.dir === "desc") out.dir = search.dir;
  return out;
}

/** `/app/admin/messages` filters (FR-FE14-24), kept in the URL. */
export function validateAdminMessagesSearch(search: Record<string, unknown>): AdminMessagesSearch {
  return {
    ...pick(search, "channel status", /^[a-z_]{1,20}$/),
    ...pick(search, "template", /^[\w.-]{1,60}$/),
  };
}
